module.exports = __webpack_public_path__ + "images/help/icon-twr41@2x-0dde70fd0fb7e054f9b566ed830bb599.png";